<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="650px">
      <v-card class="grid">
        <!-- close -->
        <v-toolbar elevation="0">
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <!-- steps -->
        <v-card-text class="my-0 py-0 px-10 carrousel">
          <div
            v-for="(step, stepIndex) in steps"
            :key="`step-${stepIndex}`"
            :class="{ active: stepIndex === currentStep }"
            class="carrousel__item"
          >
            <v-img aspect-ratio="1" contain eager :src="step.src" />
            <div class="text-h4 mt-6 px-12">{{ step.title }}</div>
            <div
              class="text-subheading text-center mt-6"
              v-html="step.subtitle"
            />
            <v-row no-gutters justify="center" align="center" class="pt-8">
              <div
                v-for="(_, dotIndex) in steps"
                :key="`dot-${dotIndex}`"
                :class="stepIndex === dotIndex ? 'filledStep' : 'blankStep'"
                class="mx-1"
              />
            </v-row>
          </div>
        </v-card-text>

        <!-- actions -->
        <v-card-actions class="px-8 py-6">
          <v-row no-gutters justify="center" align="center">
            <template>
              <template v-if="hasFinished">
                <v-col cols="6">
                  <v-btn
                    large
                    elevation="0"
                    color="primary"
                    block
                    @click="handleClose"
                    >{{ $t('message.pages.onboardingModal.finish') }}</v-btn
                  >
                </v-col>
              </template>
              <template v-else>
                <v-col cols="5" class="mr-6">
                  <v-btn large elevation="0" block @click="handleClose">{{
                    $t('message.pages.onboardingModal.skip')
                  }}</v-btn>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    large
                    elevation="0"
                    color="primary"
                    block
                    @click="handleNextStep"
                    >{{ $t('message.pages.onboardingModal.proceed') }}</v-btn
                  >
                </v-col>
              </template>
            </template>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// external imports
import { mapMutations } from 'vuex'

// internal imports
import introMixin from '@/utils/intro.mixin.js'

export default {
  name: 'OnboardingModal',
  components: {},
  mixins: [introMixin],
  data: () => ({
    open: false,
    currentStep: 0,
    timeout: null,
    delay: 6000,
    times: 0,
  }),
  computed: {
    steps() {
      const i18n = this.$i18next
      const path = 'message.pages.onboardingModal'

      return [
        {
          src: require('@/assets/onboardingImage1.svg'),
          title: i18n.t(`${path}.firstStepTitle`),
          subtitle: i18n.t(`${path}.firstStepSubtitle`),
        },
        {
          src: require('@/assets/onboardingImage2.svg'),
          title: i18n.t(`${path}.secondStepTitle`),
          subtitle: i18n.t(`${path}.secondStepSubtitle`),
        },
        {
          src: require('@/assets/onboardingImage3.svg'),
          title: i18n.t(`${path}.thirdStepTitle`),
          subtitle: i18n.t(`${path}.thirdStepSubtitle`),
        },
      ]
    },
    hasFinished() {
      return this.times >= this.steps.length - 1
    },
  },
  mounted() {
    this.$root.$on('openOnboardingModal', () => {
      this.open = true
    })
  },
  watch: {
    open(value) {
      if (value) {
        this.start()
      } else {
        this.reset()
        this.refreshIntro()
        this.UPDATE_FIRST_ACCESS(false)
      }
    },
    currentStep(value) {
      if (this.open) {
        clearTimeout(this.timeout)

        if (value < this.steps.length) this.start()
        else {
          this.currentStep = 0
        }

        this.times += 1
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('openOnboardingModal')
    this.reset()
  },
  methods: {
    ...mapMutations('user', ['UPDATE_FIRST_ACCESS']),
    handleClose() {
      this.open = false
    },
    handleNextStep() {
      this.currentStep += 1
    },
    start() {
      if (this.open) {
        this.timeout = setTimeout(() => this.handleNextStep(), this.delay)
      }
    },
    reset() {
      clearTimeout(this.timeout)
      this.currentStep = 0
      this.times = 0
      this.timeout = null
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin grid($rows, $columns) {
  display: grid;
  grid-template-rows: $rows;
  grid-template-columns: $columns;
}
.grid {
  @include grid(auto 50vh auto, 1fr);
}

.carrousel {
  display: flex;

  text-align: center;

  &__item {
    display: none;

    &.active {
      @include grid(repeat(4, auto), 1fr);

      animation: slide-in 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

      @keyframes slide-in {
        0% {
          transform: translateX(20px);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }
    }
  }
}
</style>

<style>
.fieldText {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.05em;
  color: #333333;
}

.blankStep {
  width: 12px;
  height: 12px;
  background: #e9e9ff;
  border-radius: 50px;
}

.filledStep {
  width: 50px;
  height: 12px;
  background: #4874f1;
  border-radius: 50px;
}
</style>
